import globals from "imports/globals";
import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

const component = (function () {
    gsap.registerPlugin(ScrollTrigger);

    $(document).ready(function () {
        if ($(".layout-hanse-bar").length) {
            if (globals.debug) console.log("layout-hanse-bar initialized");

            ScrollTrigger.create({
                trigger: $(".layout-hanse-bar .hero-bar")[0],
                start: `top bottom-=${window.innerHeight * 0.1}`,
                end: `+=${window.innerHeight * 2}`,
                onToggle: function (_self) {
                    $(_self.trigger).toggleClass("on");
                },
                // markers: true,
            });
        }
    });
})();

export default component;
